export const config = {
    appname: 'tbank',
    agencyId: '104468',
    client_id: '1007101429346759', // App ID
    facebook_app_id: '1007101429346759', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'apitni2',
    bzbsUrl: 'https://apitni2.buzzebees-uat.com',
    bzbsModuleUrl: 'https://tbankmodule.buzzebees-uat.com',
    apiShoppingCartUrl: 'https://shoppingcartmodule23.buzzebees-uat.com',
    webShoppingCartUrl: 'https://shoppingcartservice23.buzzebees-uat.com',
    // bzbsBlobUrl: 'https://cdn.buzzebees-uat.com/th',
    bzbsBlobUrl: 'https://cdn.buzzebees-uat.com/th',
    miscUrl: 'https://stgmisc.buzzebees.com',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "AIzaSyDcktBQ9kdeC1KTPBBpIbKsEE_iOdUE7ME",
        authDomain: "tni-line-stg.firebaseapp.com",
        projectId: "tni-line-stg",
        storageBucket: "tni-line-stg.appspot.com",
        messagingSenderId: "185777020057",
        appId: "1:185777020057:web:3020ffbc9e250e0ab4ec08",
        measurementId: "G-KCY6KEZBWV"
    },
    lineId: "@test_thanachart",
};
